import Link from "next/link";
import { VFC } from "react";
import { Member } from "../../types/types";
import { StepProgressBar } from "./StepProgressBar";

interface StepProps {
  step: number;
  register: any;
  user: Member;
  errors: any;
}

export const Step2: VFC<StepProps> = ({ step, register, user, errors }) => {
  return (
    <>
      <div className="l-container">
        <StepProgressBar step={step} />

        <div className="p-pageTtl">
          <div className="p-pageTtl__inner">
            <h2 className="p-pageTtl__ttl">基本情報</h2>
          </div>
        </div>
      </div>

      <div className="l-container -sm">
        <div className="p-form">
          {user.company_flag ? (
            <div className="p-form__item">
              <p className="p-form__label">
                <i className="-req">必須</i>法人名
              </p>
              <div className="p-form__input">
                <input
                  type="text"
                  {...register("company_name", { required: true })}
                  defaultValue={user.company_name ?? ""}
                  placeholder="例）地域　未来"
                />
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>
              {user.company_flag ? "ご担当者名" : "氏名"}
            </p>
            <div className="p-form__input">
              <input
                type="text"
                {...register("name", { required: true })}
                defaultValue={user.name ?? ""}
                placeholder="例）地域　未来"
              />
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>郵便番号
            </p>
            <div className="p-form__input">
              <input
                {...register("zip_code", { required: true })}
                defaultValue={user.zip_code ?? ""}
                type="text"
                placeholder="例）000-0000"
              />
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>都道府県
            </p>
            <div className="p-form__input -select">
              <select {...register("region", { required: true })}>
                <option value="" selected>
                  選択してください
                </option>
                <option value="北海道">北海道</option>
                <option value="青森県">青森県</option>
                <option value="岩手県">岩手県</option>
                <option value="宮城県">宮城県</option>
                <option value="秋田県">秋田県</option>
                <option value="山形県">山形県</option>
                <option value="福島県">福島県</option>
                <option value="茨城県">茨城県</option>
                <option value="栃木県">栃木県</option>
                <option value="群馬県">群馬県</option>
                <option value="埼玉県">埼玉県</option>
                <option value="千葉県">千葉県</option>
                <option value="東京都">東京都</option>
                <option value="神奈川県">神奈川県</option>
                <option value="新潟県">新潟県</option>
                <option value="富山県">富山県</option>
                <option value="石川県">石川県</option>
                <option value="福井県">福井県</option>
                <option value="山梨県">山梨県</option>
                <option value="長野県">長野県</option>
                <option value="岐阜県">岐阜県</option>
                <option value="静岡県">静岡県</option>
                <option value="愛知県">愛知県</option>
                <option value="三重県">三重県</option>
                <option value="滋賀県">滋賀県</option>
                <option value="京都府">京都府</option>
                <option value="大阪府">大阪府</option>
                <option value="兵庫県">兵庫県</option>
                <option value="奈良県">奈良県</option>
                <option value="和歌山県">和歌山県</option>
                <option value="鳥取県">鳥取県</option>
                <option value="島根県">島根県</option>
                <option value="岡山県">岡山県</option>
                <option value="広島県">広島県</option>
                <option value="山口県">山口県</option>
                <option value="徳島県">徳島県</option>
                <option value="香川県">香川県</option>
                <option value="愛媛県">愛媛県</option>
                <option value="高知県">高知県</option>
                <option value="福岡県">福岡県</option>
                <option value="佐賀県">佐賀県</option>
                <option value="長崎県">長崎県</option>
                <option value="熊本県">熊本県</option>
                <option value="大分県">大分県</option>
                <option value="宮崎県">宮崎県</option>
                <option value="鹿児島県">鹿児島県</option>
                <option value="沖縄県">沖縄県</option>
              </select>

              {errors.region && (
                <p className="text-red-600">都道府県を選択してください</p>
              )}
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>
              {user.company_flag ? "所在地" : "住所"}
            </p>
            <div className="p-form__input">
              <input
                {...register("address", { required: true })}
                defaultValue={user.address ?? ""}
                type="text"
                placeholder="例）島根県松江市中原町167-1　第２坂田ビル1F"
              />
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>電話番号
            </p>
            <div className="p-form__input">
              <input
                {...register("phone_number", { required: true })}
                defaultValue={user.phone_number ?? ""}
                type="tel"
                placeholder="例）00-0000-0000"
              />
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>メールアドレス
            </p>
            <div className="p-form__input">
              <input
                {...register("email_address", { required: true })}
                defaultValue={user.email_address ?? ""}
                type="email"
                placeholder="例）rei@chiki-mirai.jp"
              />
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">
              <i className="-req">必須</i>パスワード
            </p>
            <div className="p-form__input">
              <input
                {...register("password", {
                  required: true,
                  minLength: {
                    value: 8,
                    message: "パスワードは8文字以上で入力してください",
                  },
                })}
                defaultValue={user.password ?? ""}
                type="password"
                placeholder=""
              />
              {errors.password?.message && (
                <p className="text-red-600">{errors.password?.message}</p>
              )}
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">領収書の有無</p>
            <div className="p-form__cols">
              <div className="p-form__colsCol">
                <div className="p-form__input -radio">
                  <label>
                    <input
                      {...register("receipt", { required: true })}
                      type="radio"
                      value="true"
                      defaultChecked={user.receipt}
                    />
                    <span>必要</span>
                  </label>
                </div>
              </div>
              <div className="p-form__colsCol">
                <div className="p-form__input -radio">
                  <label>
                    <input
                      {...register("receipt", { required: true })}
                      type="radio"
                      value="false"
                      defaultChecked={!user.receipt}
                    />
                    <span>不要</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">領収書の宛名</p>
            <div className="p-form__input">
              <input
                {...register("receipt_address")}
                defaultValue={user.receipt_address ?? ""}
                type="text"
                placeholder="例）地域　未来"
              />
            </div>
            <p className="p-form__inputNote">
              ※お申込者とお名前が違う場合、または、団体名・企業名をご希望の場合はご入力ください
            </p>
          </div>

          <div className="p-form__item">
            <p className="p-form__label">お申し込みのきっかけ</p>
            <div className="p-form__input">
              <textarea
                {...register("motivation")}
                defaultValue={user.motivation ?? ""}
                placeholder="例）"
                rows={8}
              ></textarea>
            </div>
          </div>

          <div className="p-form__privacy">
            <p className="p-form__label">
              <i className="-req">必須</i>
            </p>
            <div className="p-form__privacyInner">
              <div className="p-form__input -checkbox">
                <label>
                  <input
                    {...register("confirm_terms", {
                      required: true,
                    })}
                    type="checkbox"
                  />
                  <span>個人情報の取り扱いに同意する</span>
                </label>
              </div>
              <div className="p-form__privacyTxt">
                <p>
                  お預かりした個人情報は、活動のご報告、領収書やお礼状などの送付、支援のお願い等、当団体の活動のためにのみ使用し適切な管理を行います
                </p>
                <p>
                  <Link href="/privacy_policy">
                    <a target="_blank">{">"}個人情報の取り扱いについて</a>
                  </Link>
                </p>
              </div>
            </div>
            {errors.confirm_terms && (
              <div>
                <p className="text-red-600">同意するにチェックをしてください</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
